import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointService } from '../../services/breakpoint.service';
import { CurrentRouteService } from '../../services/current-route.service';
import { ApplicationFabContentComponent } from '../application-fab-content/application-fab-content.component';
import { ApplicationInfoPanelComponent } from '../application-info-panel/application-info-panel.component';
import { MenuBarComponent } from '../menu-bar/menu-bar.component';
import { DonationComponent } from '../../modules/donation';
import { FeatureDynamicService } from '../../modules/feature-dynamic';

@Component({
    selector: 'app-main',
    imports: [
        AsyncPipe,
        RouterOutlet,
        MenuBarComponent,
        ApplicationFabContentComponent,
        ApplicationInfoPanelComponent,
        DonationComponent
    ],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MainComponent {
  readonly breakpointService = inject(BreakpointService);
  readonly currentRouteService = inject(CurrentRouteService);
  readonly featureDynamicService = inject(FeatureDynamicService);

}
